<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiEmailOpenOutline } from "@mdi/js";
export default {
  name: "MdiEmailOpenOutline",
  data() {
    return {
      svgPath: mdiEmailOpenOutline,
    };
  },
};
</script>
